<template>
  <div class="sidebar__container">
    <div class="sidebar__row">
      <nav class="links-col">
        <ul class="links-col__links">
          <NavMenuItem v-for="(item, index) in menuItems" :item="item" :key="index"></NavMenuItem>
        </ul>
      </nav>
    </div>
    <ContactTeamMenu></ContactTeamMenu>
    <div class="sidebar__row">
      <LogoutItem></LogoutItem>
    </div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import NavMenuItem from './NavMenuItem.vue';
  import ContactTeamMenu from './ContactTeamMenu.vue';
  import LogoutItem from './nav-menu-items/LogoutItem.vue';

  export default {
    name: 'NavMenu',
    components: {
      NavMenuItem,
      ContactTeamMenu,
      LogoutItem,
    },
    computed: {
      ...mapGetters('main', ['menuItems']),
    },
  }
</script>
